import axios from "axios";
import { getToken, removeToken, verifyCurrentVersion } from "./auth";
import { Notification } from "element-ui";

const baseURL = process.env.NODE_ENV === "development" ? "/" : "/";

const CLIENT = {
  CLIENT_TYPE_PC: 1, // web
  CLIENT_TYPE_APP: 2, // app
  CLIENT_TYPE_WECHAT: 3, // 小程序
  CLIENT_TYPE_H5: 4, // h5
};

const SYSTEM = {
  SYSTEM_WEB: 1, // 门户
  SYSTEM_TRANSACTION: 2, // 交易小程序
  SYSTEM_MANAGE: 3, // 管理后台
};

const instance = axios.create({
  baseURL,
  timeout: 20000,
});

// 添加请求拦截器
instance.interceptors.request.use(
  function (config) {
    // 在发送请求之前做些什么
    const token = getToken();
    // noNeedToken 是否不需要token
    if (!config.noNeedToken && token) {
      config.headers["token"] = token;
    }

    config.headers["client"] = CLIENT.CLIENT_TYPE_PC;
    config.headers["system"] = SYSTEM.SYSTEM_WEB;
    return config;
  },
  function (error) {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

// 添加响应拦截器
instance.interceptors.response.use(
  function (response) {
    // 2xx 范围内的状态码都会触发该函数。
    // 对响应数据做点什么

    // 校验当前版本是否需要刷新
    verifyCurrentVersion(response);

    // rawResponse 为 true 时不解析业务数据（如直接返回图片流的接口）
    if (response.config && response.config.rawResponse) {
      return response;
    }

    if (response.data.code === 0) {
      // 响应数据中的
      return response.data;
    }

    // 身份验证失败
    if (response.data.code === 401) {
      removeToken();
    }

    Notification.error({
      title: "温馨提示",
      message: response.data.message,
    });

    return Promise.reject(response);
  },
  function (error) {
    // 超出 2xx 范围的状态码都会触发该函数。
    // 对响应错误做点什么

    Notification.error({
      title: "温馨提示",
      message: error.message,
    });

    return Promise.reject(error);
  }
);

export default instance;
